import usersActions from "./usersActions";

const allUsersActions = {
  usersActions,
};

export default allUsersActions;
